import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Question} from './question.model';

@Injectable()
export class QuestionService {

    private resourceUrl = 'api/questions';
    private resourcePublicUrl = 'api/public/questions';

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http) { }

    create(question: Question): Observable<Question> {
        let copy: Question = Object.assign({}, question);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(questions: Question[]): Observable<Question[]> {
        let copy: Question[] = questions.slice(0);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Question> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.categorieIdList) {
            params.set('categorieIdList', req.categorieIdList);
        }
        if (req && req.formationId) {
            params.set('formationId', req.formationId);
        }
        if (req && req.interne != null) {
            params.set('interne', req.interne);
        }
        return this.http.get(this.resourcePublicUrl, { search: params })
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/question.service.ts